<form [formGroup]="licenceForm" class="flex-column h-100">
  <div class="configuration-wizard-header">
    <h5
      class="odx-title-5"
      i18n="@@centralStationConfiguration.licenceSelector.header"
      data-testid="centralStationConfiguration.licenceSelector.header"
    >
      {{ title }}
    </h5>

    <div odxLayout="flex gap-small" class="filters">
      <odx-form-field i18n-label="@@centralStationConfiguration.licenceSelector.filterPatients" label="Number of Patients">
        <odx-select
          odxFormFieldControl
          formControlName="filterPatients"
          multiple
          i18n-placeholder="@@centralStationConfiguration.licenceSelector.filterPatients.placeholder"
          placeholder="Kein Filter"
        >
          @if (patientFilterOptions$ | async; as options) {
            @for (value of options | odxAutocompleteSearchFilter; track value) {
              <odx-select-option [value]="value">{{ value }}</odx-select-option>
            }
          }
          <input
            placeholder="Nach Patientenzahl suchen..."
            i18n-placeholder="@@centralStationConfiguration.licenceSelector.filterPatients.search.placeholder"
            odxSelectSearchField="Kein Ergebnis"
            i18n-odxSelectSearchField="@@centralStationConfiguration.licenceSelector.filterPatients.search.noResult"
          />
        </odx-select>
      </odx-form-field>

      <odx-form-field i18n-label="@@centralStationConfiguration.licenceSelector.filterRetention" label="Data Retention Time">
        <odx-select
          odxFormFieldControl
          formControlName="filterRetention"
          multiple
          i18n-placeholder="@@centralStationConfiguration.licenceSelector.filterRetention.placeholder"
          placeholder="Kein Filter"
        >
          @if (retentionFilterOptions$ | async; as options) {
            @for (value of options | odxAutocompleteSearchFilter; track value) {
              <odx-select-option [value]="value">{{ value }}</odx-select-option>
            }
          }
          <input
            placeholder="Nach Aufbewahrungszeit suchen..."
            i18n-placeholder="@@centralStationConfiguration.licenceSelector.filterRetention.search.placeholder"
            odxSelectSearchField="Kein Ergebnis"
            i18n-odxSelectSearchField="@@centralStationConfiguration.licenceSelector.filterRetention.search.noResult"
          />
        </odx-select>
      </odx-form-field>
    </div>

    <app-filter-product (searchEvent)="search($event)"></app-filter-product>
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    @if (step?.options) {
      <odx-radio-group formControlName="selectedLicence" required="true" class="h-100 overflow-hidden">
        @if (showCategoryHeaders) {
          @if (singleOptionDisplays$ | async; as singleOptions) {
            @if (singleOptions.length > 0) {
              <h6 class="odx-title-6 section-title" i18n="@@centralStationConfiguration.licenceSelector.singleHeader">
                Einzellizenzen
              </h6>
              <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
                @for (option of singleOptions; track option) {
                  <app-monitoring-option-card
                    [option]="option"
                    [isSelected]="isOptionSelected(option)"
                    [selectionMode]="step!.stepSelectionType"
                    [category]="category"
                    [categoryLabel]="categoryLabel"
                    (click)="select(option)"
                    (select$)="select(option)"
                  >
                  </app-monitoring-option-card>
                }
              </div>
            }
          }
          @if (groupedOptionDisplays$ | async; as groupedOptions) {
            @if (groupedOptions.length > 0) {
              <h6 class="odx-title-6 section-title" i18n="@@centralStationConfiguration.licenceSelector.groupHeader">
                Lizenzpakete
              </h6>
              <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
                @for (option of groupedOptions; track option) {
                  <app-monitoring-option-card
                    [option]="option"
                    [isSelected]="isOptionSelected(option)"
                    [selectionMode]="step!.stepSelectionType"
                    [category]="category"
                    [categoryLabel]="categoryLabel"
                    (click)="select(option)"
                    (select$)="select(option)"
                  >
                  </app-monitoring-option-card>
                }
              </div>
            }
          }
        } @else {
          @if (sortedOptionDisplays$ | async; as sortedOptions) {
            @if (sortedOptions.length > 0) {
              <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
                @for (option of sortedOptions; track option) {
                  <app-monitoring-option-card
                    [option]="option"
                    [isSelected]="isOptionSelected(option)"
                    [selectionMode]="step!.stepSelectionType"
                    [category]="category"
                    [categoryLabel]="categoryLabel"
                    (click)="select(option)"
                    (select$)="select(option)"
                  >
                  </app-monitoring-option-card>
                }
              </div>
            }
          }
        }
      </odx-radio-group>
    }
  </odx-content-box>
</form>
